export const localStorageKey = {
    SET_USERINFO: 'SET_USERINFO',
    SET_PERMS: 'SET_PERMS',
    SET_ROUTES: 'SET_ROUTES',
    ACCESS_TOKEN_QILANG: 'ACCESS_TOKEN_QILANG',
    EXPIRES_AT_QILANG: 'EXPIRES_AT_QILANG',
};
